



















































































































import Vue, { PropType } from 'vue';
import FieldButton from '@/components/form/FieldButton.vue';
import Accordion from '@/components/accordion/Accordion.vue';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import ChipsElement from '@/components/chips/ChipsElement.vue';
import RightSlidePopup from '@/components/popups/RightSlidePopup.vue';
import ChipsTree, {
  IChipsTree,
  INormalizeTreeData,
  IChipTreeData,
} from '@/utils/ChipsTree';

export default Vue.extend({
  name: 'SelectChipsFromRightSlide',
  components: {
    RightSlidePopup,
    FieldButton,
    Accordion,
    FieldCheckbox,
    ChipsElement,
  },
  props: {
    chipsList: {
      type: Array as PropType<Array<IChipTreeData>>,
      default: null,
    },
    chipsData: {
      type: Array as PropType<Array<IChipTreeData>>,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    isLabel: {
      type: Boolean,
      default: true,
    },
    isEmptyMessage: {
      type: String,
      default: 'notifications.categoryEmpty',
    },
    textButton: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
    dataTestId: {
      type: String,
      required: false,
      default: '',
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mounted() {
    this.sortLocalChipsData();
  },
  watch: {
    chipsList(newValue, oldValue) {
      if (newValue?.length !== oldValue?.length) {
        this.sortLocalChipsData();
      }
    },
    chipsData(newValue, oldValue) {
      if (newValue?.length !== oldValue?.length) {
        this.sortLocalChipsData();
      }
    },
  },

  computed: {
    chipsTree(): IChipsTree {
      return new ChipsTree(this.chipsList, this.multiple);
    },
    chips(): INormalizeTreeData<IChipTreeData> {
      return this.chipsTree.chips || null;
    },
    tree(): INormalizeTreeData<Array<number>> {
      return this.chipsTree.tree || null;
    },
    dataIsNotEmpty(): boolean {
      return this.chips?.allIds?.length > 0 && this.tree?.allIds?.length > 0;
    },
  },

  methods: {
    sortLocalChipsData() {
      if (!this.chipsList?.length || !this.chipsData?.length) return;

      this.chipsTree.changeAllIsActive(this.chipsData);
      this.updateChipsData();
    },
    changeParent(parentId: number) {
      this.chipsTree.changeParentChips(parentId);
      this.updateChipsData();
    },
    changeChild(childId: number) {
      this.chipsTree.toggleIsActive(childId);
      this.updateChipsData();
    },
    updateChipsData() {
      this.localChipsData = this.chipsTree.getActiveChips();
      this.changeEvent();
    },
    removeChipFromLocalChipsData(chipId: number) {
      this.chipsTree.toggleIsActive(chipId);
      this.updateChipsData();
    },
    checkPartlyChecked(parentId: number) {
      if (!this.multiple) {
        return false;
      }

      const someChildIsActive = this.tree.byId[parentId].filter(
        (chipId) => this.chips.byId[chipId].isActive
      );
      const parentIsActive = this.chips.byId[parentId].isActive;
      const parentChildrensLength = this.tree.byId[parentId].length;

      if (!parentChildrensLength) {
        return false;
      }

      return (
        (someChildIsActive.length > 0 &&
          someChildIsActive.length !== parentChildrensLength &&
          parentChildrensLength > 0) ||
        (parentIsActive && someChildIsActive.length === 0) ||
        (!parentIsActive && someChildIsActive.length > 0)
      );
    },
    changeEvent() {
      this.$emit('change', this.localChipsData);
    },
    closePopup() {
      this.chipsPopup = false;
      this.$emit('close');
    },
  },
  data() {
    return {
      localChipsData: [] as Array<IChipTreeData> | any,
      chipsPopup: false,
    };
  },
});
